import React from 'react';

export const Trash = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6H5a1 1 0 0 0 0 2h1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8h1a1 1 0 1 0 0-2Zm-3 13H8V8h8v11ZM10 5h4a1 1 0 1 0 0-2h-4a1 1 0 0 0 0 2Z" />
        <path d="M10 17a1 1 0 0 0 1-1v-5a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1ZM14 17a1 1 0 0 0 1-1v-5a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1Z" />
    </svg>
);
